import {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';
import useShow from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import {getEventTickets} from '../../../../../redux/tickets/ticketsActions';
import {POPUP_DURATION} from '../../../../../globalVariables/GlobalVariables';
import TicketsPopupContent from '../../../../tickets/ticketsPopUp/basicTicket/ticketsPopupContent/TicketsPopupContent';
import TicketsSection from '../fields/TicketsSection';

const TicketsTab: FC = () => {
    const tickets = useSelector((state: RootState) => state.tickets.tickets);
    const ticketCreateShow = useShow(POPUP_DURATION);

    useEffect(() => {
        if(!tickets?.length) getEventTickets();
    }, []);

    return (
        <>
            <TicketsSection onCreateTicket={ticketCreateShow.open} />
            {ticketCreateShow.isOpen && (
                <TicketsPopupContent
                    tid={undefined}
                    close={ticketCreateShow.close}
                    showClass={ticketCreateShow.showClass}
                />
            )}
        </>
    );
};

export default TicketsTab;
